module.exports = __webpack_public_path__ + "static/img/27-2.066518f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/27-2.jpg
// module id = D8fI
// module chunks = 0